import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()

    return {
        key: 'refresh-product',
        label: '重载',
        onClick: () => map.refresh(),
    }
}
